import api from "./api";

// Capa de servicios API del dominio "campañas de flujo" (flowcampaigns) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const listFlowCampaigns = () => api.get("/flowcampaigns");
export const createFlowCampaign = (payload) => api.post("/flowcampaigns", payload);
export const updateFlowCampaign = (flowCampaignId, payload) =>
  api.put(`/flowcampaigns/${flowCampaignId}`, payload);
export const deleteFlowCampaign = (flowCampaignId) =>
  api.delete(`/flowcampaigns/${flowCampaignId}`);
